// Checks only if the token is not expired yet (with 5 mins window)
const isTokenValid = (token) => {
  if (!token || typeof token !== 'string') {
    console.error("Invalid token type : ", typeof token);
    return false;
  }

  let payload = token.split('.')[1];
  payload = JSON.parse(new Buffer(payload, 'base64').toString('ascii'));
  return (payload['exp'] - 300) * 1000 > (new Date()).getTime();
}

const getRandomInt = (max=100) => {
  return Math.floor(Math.random() * Math.floor(max));
}

export {
  isTokenValid,
  getRandomInt
};


// WEBPACK FOOTER //
// ./src/app/utils.js